import { useSelect } from "@wordpress/data";
import { useState } from "@wordpress/element";
import { CityName } from "../city-name/CityName";
import { WEATHER_STORE } from "@/store/store";
import { WeatherSelect } from "@/store/type";
import { getForecastByDate } from "@/helpers/format-forecast-data-by-date";
import { useTranslation } from "react-i18next";

import PrevisionTableSmall from "@/components/prevision-table-small/PrevisionTableSmall";
import PrevisionButton from "../prevision-button/PrevisionButton";
import Skeleton from "@/components/skeletons/Skeleton";

import "./style.scss";

export const PrevisionList = () => {
	const { t } = useTranslation();
	const { forecastData, isLoading, error } = useSelect(
		(select: (store: typeof WEATHER_STORE) => WeatherSelect) =>
			select(WEATHER_STORE).getCityPrevisionState(),
		[],
	);

	const [selectedDate, setSelectedDate] = useState<Date>(new Date());

	const dataToMap = getForecastByDate({
		selectedDate,
		forecastData: forecastData ? forecastData.data : [],
	});

	return (
		<div className="prevision-list">
			<PrevisionButton
				selectedDate={selectedDate}
				setDate={(date) => setSelectedDate(() => date)}
			/>

			<CityName />

			{isLoading ? (
				<div className="loader">
					<Skeleton length={8} />
				</div>
			) : error ? (
				<div className="error">
					<p>{t("fetchError")}</p>
				</div>
			) : (
				forecastData && <PrevisionTableSmall data={dataToMap} />
			)}
		</div>
	);
};

export default PrevisionList;
